var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureTileIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 43v-6.3a8.97 8.97 0 003-6.569A9.1 9.1 0 0033.262 21 9 9 0 0024 30v1l-2 5 2 1v4a2 2 0 002 2h4a5 5 0 005-5v-5",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#ACADFF",
    cx: 35,
    cy: 30,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon04);
export default __webpack_public_path__ + "static/media/feature-tile-icon-04.1acd4dacd4ddf306c2e7f5da116b6137.svg";
export { ForwardRef as ReactComponent };